import FilesCategoriesIcon from '@material-ui/icons/TurnedIn';
import FilesCategoriesList from './FilesCategoriesList';
import FilesCategoriesShow from './FilesCategoriesShow';

const FilesCategoriesModule = {
    list: FilesCategoriesList,
    show: FilesCategoriesShow,
    icon: FilesCategoriesIcon,
}; export default FilesCategoriesModule;